import { Control, Controller } from 'react-hook-form';
import Autocomplete, { SuggestionProps } from './AppAutocomplete';

interface IAutocompleteFieldProps {
  control?: Control<any>;
  disabled?: boolean;
  error?: string;
  name: string;
  onSelect?: (value: SuggestionProps) => void;
  placeholder?: string;
  suggestions: SuggestionProps[];
}

const AutocompleteField = ({
  control,
  disabled,
  error,
  name,
  onSelect,
  placeholder,
  suggestions,
}: IAutocompleteFieldProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <Autocomplete
            disabled={disabled}
            error={error}
            placeholder={placeholder}
            suggestions={suggestions}
            value={field.value?.value}
            onSelect={(value) => {
              field.onChange(value);
              onSelect?.(value);
            }}
          />
        );
      }}
    />
  );
};

export default AutocompleteField;
